/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Zobrazit méně`
};

const da_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Vis mindre`
};

const de_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Weniger anzeigen`
};

const en_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Show less`
};

const es_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Ver menos`
};

const fr_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Voir moins`
};

const hu_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Kevesebb`
};

const it_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Mostra meno`
};

const nl_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Minder tonen`
};

const pl_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Pokaż mniej`
};

const pt_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Ver menos`
};

const sv_show_less = /** @type {(inputs: {}) => string} */ () => {
	return `Visa mindre`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const show_less = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.show_less(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("show_less", locale)
	if (locale === "cs") return cs_show_less(inputs)
	if (locale === "da") return da_show_less(inputs)
	if (locale === "de") return de_show_less(inputs)
	if (locale === "en") return en_show_less(inputs)
	if (locale === "es") return es_show_less(inputs)
	if (locale === "fr") return fr_show_less(inputs)
	if (locale === "hu") return hu_show_less(inputs)
	if (locale === "it") return it_show_less(inputs)
	if (locale === "nl") return nl_show_less(inputs)
	if (locale === "pl") return pl_show_less(inputs)
	if (locale === "pt") return pt_show_less(inputs)
	return sv_show_less(inputs)
};